<script setup>
import { useAttrs } from 'vue';

const attrs = useAttrs();
</script>

<template>
  <!-- Vartana mark: transparent, color follows theme via currentColor -->
  <svg
    v-bind="attrs"
    class="text-[#081321] dark:text-n-brand"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.49,11.56c-.09.13-.22.19-.35.22-.12.02-.21-.02-.29-.1l-.71-.71c-.21-.2-.07-.54.18-.7l2.29-1.38-.05-.19-2.62-.12c-.19,0-.35-.06-.47-.2-.06-.08-.1-.19-.07-.29l.32-1c.05-.16.35-.23.62-.11l1.48.72c1.02.49,1.69,1.39,1.83,2.51l.13,1.36c.01.13-.05.31-.17.36l-.65.26c-.07.03-.15,0-.19-.05-.06-.08-.08-.18-.06-.29l.39-2.36-.12-.07-1.5,2.15Z"
    />
    <path
      d="M8.56,9.12c.03.19.14.29.28.3.16,0,.27-.09.31-.26l1.4-4.97c.75.28,1.43.66,2.06,1.17l-2.83,4.3c-.21.34-.57.52-.92.52-.4,0-.74-.19-.95-.54l-2.85-5.19c.71-.33,1.44-.54,2.19-.63l1.31,5.32Z"
    />
  </svg>
</template>
